import CommonFieldName from "./CommonFieldName";

enum PersonFieldName {
  NAME = CommonFieldName.NAME, // fullName
  FIRST_NAME = "firstName",
  LAST_NAME = "lastName",
  ADDRESS = "address",
  CITY = "city",
  REGION = "region",
  POSTAL_CODE = "postalCode",
  COUNTRY = "countryCode",
  PHONE = "phone",
  CRM_LINK = CommonFieldName.CRM_LINK,
  EMAIL = CommonFieldName.EMAIL,
  FILES = CommonFieldName.FILES,
  GROUPS = CommonFieldName.GROUPS,
  DAYS_LEFT_IN_FREQUENCY = CommonFieldName.DAYS_LEFT_IN_FREQUENCY,
  COLOR = CommonFieldName.COLOR,
  CREATOR = CommonFieldName.CREATOR,
  CREATOR_NAME = CommonFieldName.CREATOR_NAME,
  CREATOR_EMAIL = CommonFieldName.CREATOR_EMAIL,
  USER = CommonFieldName.USER,
  OWNER_NAME = CommonFieldName.OWNER_NAME,
  OWNER_EMAIL = CommonFieldName.OWNER_EMAIL,
  NEXT_ACTIVITY = CommonFieldName.NEXT_ACTIVITY,
  LAST_ACTIVITY_DATE = CommonFieldName.LAST_ACTIVITY_DATE,
  LAST_ACTIVITY_TYPE = CommonFieldName.LAST_ACTIVITY_TYPE,
  LAST_ACTIVITY_NAME = CommonFieldName.LAST_ACTIVITY_NAME,
  FREQUENCY_STATUS = CommonFieldName.FREQUENCY_STATUS,
  FREQUENCY_INTERVAL = CommonFieldName.FREQUENCY_INTERVAL,
  NO_CONTACT_IN = CommonFieldName.NO_CONTACT_IN,
  NOTES = CommonFieldName.NOTES,
  UNIQUE_ID = CommonFieldName.UNIQUE_ID,
  GEOPOINT = CommonFieldName.GEOPOINT,
  LATITUDE = "latitude",
  LONGITUDE = "longitude",
  SOURCE = CommonFieldName.SOURCE,
  SOURCE_OBJECT = CommonFieldName.SOURCE_OBJECT,
  COMPANIES = "accounts",
  COMPANIES_ADDRESSES = "accounts.address",
  CREATED_AT = CommonFieldName.CREATED_AT,
  UPDATED_AT = CommonFieldName.UPDATED_AT,
  TEAM = CommonFieldName.TEAM,
  TERRITORIES = CommonFieldName.TERRITORIES,
  VIEW_AS = CommonFieldName.VIEW_AS,
  ROUTES = "routes",
  COMPANIES_IMPORT_ID = "accounts.importId",
  NO_CHECK_IN = "noCheckIn",
  NO_VERIFIED_CHECK_IN = "noVerifiedCheckIn",
  PRIMARY_ACCOUNT = "primaryAccount",
}

export default PersonFieldName;
